"use client";
import { pageLoadEvent, productEvent } from "@/lib/atInternetTags";
import { useEffect } from "react";
import type { Travel } from "../getTravel";
import type { Departure } from "../getDeparture";

type Props = {
  travel: Travel;
  departure: Departure | null;
};
export const At = ({ travel, departure }: Props) => {
  useEffect(() => {
    if (!departure) return;

    productEvent({
      event: "product.page_display",
      product_id: travel.id.toString(),
      product: travel.alias || "",
      product_variant: travel.travelTypeId,
      product_brand: travel.brandTitle || "",
      product_discount: departure.primoPrice !== undefined,
      product_pricetaxincluded: departure.primoPrice
        ? departure.defaultPrice - departure.primoPrice
        : departure.defaultPrice,
      product_category1: travel.destinations.find((d) => d.depth === 1)?.alias || "",
      product_category2: travel.destinations.find((d) => d.depth === 2)?.alias || "",
      product_currency: "EUR",
      speaker_ids: departure.speakers.map(({ id }) => id.toString()),
      registration_status: departure.state.registrationStatus,
      travel_duration: departure.days || 0,
      is_new_product_page: true,
    });

    pageLoadEvent({
      page: travel.alias || "",
      page_chapter1: "voyage",
      site_level2: "1",
    });
  }, [travel, departure]);

  return null;
};
